import { render, staticRenderFns } from "./interHotelDetail.vue?vue&type=template&id=b6be639a&scoped=true&"
import script from "./interHotelDetail.vue?vue&type=script&lang=js&"
export * from "./interHotelDetail.vue?vue&type=script&lang=js&"
import style0 from "./interHotelDetail.vue?vue&type=style&index=0&id=b6be639a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6be639a",
  null
  
)

export default component.exports